// Entry point for javascript creates a router to handle new routes and adds a view inside the Product Details Page

define(
	'GoVirtualOffice.HideItemOption.HideItemOption'
,   [
		'SC.Configuration',

		'product_views_option_hidden.tpl',
		'transaction_line_views_selected_option_hidden.tpl',

		'underscore'
	]
,   function (
		Configuration,

		product_views_option_hidden_tpl,
		transaction_line_views_selected_option_hidden_tpl,

		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {

			var config;
			var item_options;
			var product_view_options_selector;
			var product_view_option_facet;
			var transaction_line_view_options_selected;

			config = Configuration;

			if (config) {

				item_options = config.get('ItemOptions.optionsConfiguration', []);

				product_view_options_selector = { 'product_views_option_hidden.tpl': product_views_option_hidden_tpl };
				product_view_option_facet = { 'product_views_option_hidden.tpl': product_views_option_hidden_tpl };
				transaction_line_view_options_selected = { 'transaction_line_views_selected_option_hidden.tpl': transaction_line_views_selected_option_hidden_tpl };

				_.each(item_options, function (item_option) {

					if (item_option.templateFacetCell && product_view_option_facet[item_option.templateFacetCell]) {
						item_option.templates = item_option.templates || {};
						item_option.templates.facetCell = product_view_option_facet[item_option.templateFacetCell];
					}

					if (item_option.templateSelector && product_view_options_selector[item_option.templateSelector]) {
						item_option.templates = item_option.templates || {};
						item_option.templates.selector = product_view_options_selector[item_option.templateSelector];
					}

					if (item_option.templateSelected && transaction_line_view_options_selected[item_option.templateSelected]) {
						item_option.templates = item_option.templates || {};
						item_option.templates.selected = transaction_line_view_options_selected[item_option.templateSelected];
					}
				});
			} else {
				console.error('Missing Configuration class');
			}
		}
	};
});
